<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>

    <div class="container-fluid">
        <!-- HEADER -->
        <div class="container-fluid my-3">
            <div class="top-card">
                <div class="row w-100 mx-auto d-flex">
                    <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
                        <span>Push to Live</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- UPLOAD CARD -->
        <div class="card search-card">
            <div class="row align-items-center">
                <!-- Process Type Label -->
                <div class="col-12 col-md-2 my-2">
                    <p class="enter-title mb-0">Process Type</p>
                </div>

                <!-- Process Type Dropdown -->
                <div class="col-12 col-md-3 my-2">
                    <p-dropdown [options]="options" [(ngModel)]="selectedOption" placeholder="Select Process Type"
                        optionLabel="label" [style]="{ width: '100%', 'font-size': '12px' }">
                    </p-dropdown>
                </div>

                <!-- File Upload -->
                <div class="col-12 col-md-3 my-2">
                    <input type="file" class="form-control" accept=".xlsx,.xls,.csv"
                        (change)="onFileSelected($event)" />
                </div>

                <!-- Upload Button -->
                <div class="col-12 col-md-2 my-2">
                    <button type="button" class="btn btn-submit w-100" (click)="uploadFile()"
                        [disabled]="!selectedFile || !selectedOption || isUploading">
                        <span *ngIf="!isUploading">Upload</span>
                        <span *ngIf="isUploading">
                            <i class="fa fa-spinner fa-spin"></i> Uploading...
                        </span>
                    </button>
                </div>

                <!-- Clear Button -->
                <div class="col-12 col-md-2 my-2">
                    <button type="button" class="btn btn-clear w-100" (click)="clearFilter()" [disabled]="isUploading">
                        Clear
                    </button>
                </div>
            </div>

            <!-- Selected File Info -->
            <div class="row" *ngIf="selectedFile">
                <div class="col-12">
                    <div class="alert alert-info mt-2 mb-2">
                        <strong>Selected File:</strong> {{ selectedFile.name }}
                        ({{ (selectedFile.size / 1024).toFixed(2) }} KB)
                    </div>
                </div>
            </div>
        </div>

        <!-- LOGS TABLE -->
        <div class="card mt-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Upload Logs</h5>
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="refreshLogs()"
                    [disabled]="isLoadingLogs">
                    <i class="fa fa-refresh" [class.fa-spin]="isLoadingLogs"></i> Refresh
                </button>
            </div>
            <div class="card-body">
                <!-- Loading State -->
                <div *ngIf="isLoadingLogs" class="text-center py-5">
                    <i class="fa fa-spinner fa-spin fa-3x"></i>
                    <p class="mt-3">Loading logs...</p>
                </div>

                <!-- No Data State -->
                <div *ngIf="!isLoadingLogs && logs.length === 0" class="text-center py-5">
                    <i class="fa fa-inbox fa-3x text-muted"></i>
                    <p class="mt-3 text-muted">No logs found</p>
                </div>

                <!-- Table -->
                <div *ngIf="!isLoadingLogs && logs.length > 0" class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>File Name</th>
                                <th>Status</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Error Message</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let log of logs; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ log.file_name }}</td>
                                <td>
                                    <span [ngClass]="getStatusClass(log.status)">
                                        {{ log.status }}
                                    </span>
                                </td>
                                <td>{{ log.start_date_script }}</td>
                                <td>{{ log.end_date_script }}</td>
                                <td>
                                    <span *ngIf="log.error_message" class="text-danger">
                                        {{ log.error_message }}
                                    </span>
                                    <span *ngIf="!log.error_message" class="text-muted">
                                        -
                                    </span>
                                </td>
                                <td>
                                    <button type="button" class="btn btn-sm btn-outline-primary me-2"
                                        (click)="downloadFile(log.input_file_path)" title="Download Input File">
                                        <i class="fa fa-download"></i> Input
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-success"
                                        (click)="downloadFile(log.output_file_path)" title="Download Output File">
                                        <i class="fa fa-download"></i> Output
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Total Count -->
                <div *ngIf="!isLoadingLogs && logs.length > 0" class="mt-3">
                    <p class="text-muted mb-0">Total Records: <strong>{{ logs.length }}</strong></p>
                </div>
            </div>
        </div>

    </div>
</div>